import type { ComparisonRow, CostRow, MetodoFeature } from '../types/content'

export const metodoFeatures: MetodoFeature[] = [
  {
    emoji: '🔬',
    title: 'Optimización metabólica',
    description:
      'Entendés cómo funciona tu metabolismo y cómo acelerar resultados con los mismos alimentos que ya estás comiendo.',
  },
  {
    emoji: '💊',
    title: 'Suplementación inteligente',
    description:
      'Qué suplementos realmente valen la pena en Argentina, cuáles son marketing puro, y cómo reemplazarlos con alimentos reales de góndola.',
  },
  {
    emoji: '💧',
    title: 'Hidratación y rendimiento',
    description:
      'Plan de hidratación semanal integrado al sistema de comidas para maximizar energía, recuperación y resultados visibles.',
  },
  {
    emoji: '🔄',
    title: 'Protocolo de hábitos 30 días',
    description:
      'El sistema paso a paso que convierte las recetas del MegaPack en un hábito automático. Para que nunca más tengas que forzarte a comer bien.',
  },
  {
    emoji: '⚡',
    title: 'Absorción proteica máxima',
    description:
      'Las combinaciones exactas de alimentos que maximizan la absorción de proteína y aceleran la ganancia muscular o la pérdida de peso según tu objetivo.',
  },
]

export const sistemaTotalRows: ComparisonRow[] = [
  {
    situation: 'Querés crear un hábito sostenible',
    without: 'Empezás bien y a la semana volvés a lo de siempre',
    with: 'Protocolo de 30 días que construye el hábito paso a paso',
  },
  {
    situation: 'No sabés qué suplementos valen la pena',
    without: 'Comprás cosas caras que quizás no necesitás',
    with: 'Guía clara de suplementación básica accesible en Argentina',
  },
  {
    situation: 'Querés maximizar resultados con lo que ya comés',
    without: 'Comés bien pero sin optimizar la absorción',
    with: 'Combinaciones exactas para absorber el 100% de la proteína',
  },
  {
    situation: 'Querés entender el por qué biológico',
    without: 'Solo tenés recetas sin contexto científico',
    with: 'Manual completo que conecta cocina, hábitos y optimización real',
  },
]

export const costRows: CostRow[] = [
  {
    emoji: '⏰',
    situation: '3 hs improvisando comida × 50 semanas',
    cost: '150 horas de tu vida por año',
  },
  {
    emoji: '📦',
    situation: 'Delivery 3 veces por semana',
    cost: '$500.000+ ARS al año perdidos',
  },
  {
    emoji: '🗑️',
    situation: 'Heladera desorganizada',
    cost: '30-40% de la comida se tira',
  },
  {
    emoji: '💸',
    situation: 'Sin vianda proteica al trabajo',
    cost: '$20.000+ por día en comida afuera',
  },
  {
    emoji: '🔄',
    situation: 'Sin sistema de hábitos',
    cost: 'El mismo ciclo el próximo año también',
  },
  {
    emoji: '😩',
    situation: 'Domingo buscando recetas en internet',
    cost: 'Estrés acumulado semana tras semana',
  },
]
